import type * as React from "react";
import { cn } from "../../lib/cn";

export type SkeletonVariant = "rect" | "text" | "circle";

export type SkeletonProps = React.ComponentProps<"div"> & {
  variant?: SkeletonVariant;
};

// Shape defaults only — sizing stays with the caller via className, same as
// the pre-variant API, so h-4 w-full max-w-[80%] etc. keep working untouched.
const variantClassName: Record<SkeletonVariant, string> = {
  rect: "rounded-md",
  text: "h-3 w-full rounded-sm",
  circle: "size-10 shrink-0 rounded-full",
};

export function Skeleton({
  variant = "rect",
  className,
  ...props
}: SkeletonProps) {
  return (
    <div
      className={cn(
        "animate-pulse bg-neutral-100 animate-shimmer",
        variantClassName[variant],
        className,
      )}
      {...props}
    />
  );
}
